<script>

export default {
        name: 'CKEditorMixin',
        data: function(){
            return { 
                computedBgColor: null,
                computedFgColor: null,
                computedFontSize: null,
            }
        },
        methods: {
            repositionToolbar: function() {
                let previewRect = document.getElementById("preview").getBoundingClientRect();
                let editorWrapper = document.getElementById("ckeditor-container");
                let editorPanel = editorWrapper.firstChild;
                let editorWidth = 0;
                let left = 0; 

                const elemRect = this.$el.getBoundingClientRect();
                const offsetTop = elemRect.top - previewRect.top;
                const offsetLeft = elemRect.left - previewRect.left;

                if (editorPanel) {

                    for (let toolbar of editorPanel.getElementsByClassName("cke_toolbar")) {
                        editorWidth += toolbar.clientWidth;
                    }

                    left = (offsetLeft + 10 + (this.$el.clientWidth - editorWidth)/2);

                    if (left + editorWidth > previewRect.width) {
                        editorWrapper.style.left = 'auto'; 
                        editorWrapper.style.right = '0px';
                    } else {
                        editorWrapper.style.left = left + 'px';
                        editorWrapper.style.right = 'auto';
                    }

                    editorWrapper.style.top = offsetTop - 40 + 'px';
                }
            },
            leaveEditMode: function(event) {
                const ckElems = [
                    document.getElementsByClassName('cke'),
                    document.getElementsByClassName('cke_dialog'),
                    document.getElementsByClassName('cke_autocomplete_panel'),
                    document.getElementsByClassName('cke_dialog_background_cover')
                ];

                for (let group of ckElems) {
                    for (let item of group) {
                        if (item.contains(event.target)) {
                            return;
                        }
                    }
                }

                if (this.$el.contains(event.target)) {
                    return;
                }

                this.isEdited = false;

                document.removeEventListener('mousedown', this.leaveEditMode, true);

                if (this.data.content !== this.content) {
                    this.content = this.data.content;
                    this.$root.syncUndoBuffer();
                }

                this.unfocus(this.data.id, event);
            },
            setContrastingFgColor: function(element) {
                if (!element) {
                    return;
                }
                this.computedBgColor = this.getVisibleBackgroundColor(element);
                let rgb = this.parseColor(this.computedBgColor);
                var o = Math.round(((parseInt(rgb[0]) * 299) + (parseInt(rgb[1]) * 587) + (parseInt(rgb[2]) * 114)) / 1000);
                this.computedFgColor = (o > 125) ? 'black' : 'white';
            },
            getVisibleBackgroundColor: function(elem) {
                var transparent = 'rgba(0, 0, 0, 0)';
                var transparentIE11 = 'transparent';
                var bg = null;

                if (!elem || elem.tagName === 'BODY') {
                    return;
                }

                bg = getComputedStyle(elem).backgroundColor;

                if (bg === transparent || bg === transparentIE11) {
                    bg = this.getVisibleBackgroundColor(elem.parentElement);
                }

                return bg;
            },
            parseColor: function(input) {
                if (input.substr(0,1)=="#") {
                    var collen=(input.length-1)/3;
                    var fact=[17,1,0.062272][collen-1];
                    return [
                        Math.round(parseInt(input.substr(1,collen),16)*fact),
                        Math.round(parseInt(input.substr(1+collen,collen),16)*fact),
                        Math.round(parseInt(input.substr(1+2*collen,collen),16)*fact)
                    ];
                } else {
                    return input.split("(")[1].split(")")[0].split(",").map(Math.round);
                }
            },
        }
    }
</script>
